// convert from Chinese symbols to Pinyin
// data from https://raw.githubusercontent.com/CNMan/Unicode/refs/heads/master/Unihan/Unihan_Readings.txt
// stored in public/chineseToPinyin.json
export let ch_to_pinyin: Record<string, string> = {};

/** set the Chinese-to-Pinyin dictionary */
export function setChineseToPinyin(data: Record<string, string>) {
  ch_to_pinyin = data;
}
